import { render } from "./wEditorFullPage.vue?vue&type=template&id=128b5f80&ts=true"
import script from "./wEditorFullPage.vue?vue&type=script&lang=ts"
export * from "./wEditorFullPage.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__